import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

type BadgeColor = 'gray' | 'red' | 'blue';

interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, 'color'> {
    color?: BadgeColor;
}

/**
 * 상태 표시용 뱃지.
 * 상태 변화 피드백은 Toast 또는 Indicator 를 사용하고,
 * 읽지 않음 개수 표기는 NumberBadge 를 사용한다.
 */
function Badge(props: Props) {
    const { color = 'gray', ...rest } = props;
    return <Base aria-label='badge'
        badgeColor={color}
        {...rest}
    />;
}

const COLOR_STYLES: Record<BadgeColor, ReturnType<typeof css>> = {
    gray: css`
        background-color: var(--color-background-raised);
        color: var(--color-text-secondary);
    `,
    red: css`
        background-color: var(--color-background-error);
        color: var(--color-text-primary);
    `,
    blue: css`
        background-color: var(--color-background-notice);
        color: var(--color-text-primary);
    `,
};

const Base = styled.span<{
    badgeColor: BadgeColor;
}>`
    align-items: center;
    border-radius: var(--radius-xs);
    display: inline-flex;
    flex-shrink: 0;
    font-size: var(--font-size-label-lg);
    font-weight: 500;
    height: 22px;
    justify-content: center;
    line-height: 1.4;
    padding: var(--spacing-1) var(--spacing-2);
    text-align: center;
    text-wrap: nowrap;
    width: fit-content;
    ${({ badgeColor }) => COLOR_STYLES[badgeColor]}
`;

export type { BadgeColor };
export default Badge;
